'use strict';

var LevelSecondaryCriteriaDirective = function LevelSecondaryCriteriaDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/level-secondary-criteria.html'),
    controller: 'LevelSecondaryCriteriaController',
    scope: {
      actionCategories: '=',
      selectedLevel: '=',
      activeEntityType: '=',
      flowType: '=',
      strategy: '=',
      onSelect: '&',
      isStatementEmpty: '=',
      rule: '=?'
    },
    link: function link($scope) {
      $scope.$watch('selectedLevel', $scope.resetGroupsAfterLevelChange);
      $scope.$on('ruleQuick:flowTypeChange', $scope.resetGroupAfterFlowTypeChange);
      $scope.$on('ruleQuick:resetLevelStrategy', $scope.resetGroupsAfterLevelChange);
    }
  };
};
LevelSecondaryCriteriaDirective.$inject = [];
module.exports = LevelSecondaryCriteriaDirective;